import { Wallet } from "lucide-react";
import { useDeposits } from "@/hooks/useDeposits";
import { formatCurrency } from "@/utils/formatters";

interface DepositBalanceProps {
  className?: string;
}

export function DepositBalance({ className = "" }: DepositBalanceProps) {
  const { primaryDeposit, hasDeposits, isLoading, isError } = useDeposits();

  if (isLoading || isError) return null;
  if (!hasDeposits || !primaryDeposit || primaryDeposit.balance <= 0) return null;

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Wallet className="h-4 w-4 shrink-0 text-primary" />
      <span className="hidden text-sm text-muted-foreground sm:inline">Счёт:</span>
      <span className="text-sm font-medium">{formatCurrency(primaryDeposit.balance)}</span>
    </div>
  );
}
